module.exports = __webpack_public_path__ + "static/img/bg.8e1d6f81.png";